module.exports = __webpack_public_path__ + "img/when-maps-become-the-world-cover.bbbd5d2b.jpg";